import { motion } from 'framer-motion';
import beneficios from '../../Assets/beneficios.png';
import beneficios_mobile from '../../Assets/beneficios_mobile.png';
import * as S from './Benefits.style';

export const Benefits = () => {
  return (
    <S.Wrapper id="Benefits">
      <S.ContentBox>
        <S.Title>
          POR QUE ESCOLHER A BINDTRACK?
        </S.Title>

        <S.SubText>
          veja o que entregamos
        </S.SubText>

        <motion.img
          src={beneficios}
          alt=""
          className="hidden md:block"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        />

        <motion.img
          src={beneficios_mobile}
          alt=""
          className="md:hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        />
      </S.ContentBox>
    </S.Wrapper>
  );
};
